import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';

const sanitise = ({...rest}) => ({
    ...rest
});

const reduceFetching = ({isFetching: state}, action) => {
    switch (action.type) {
        case ActionTypes.LRS_STATEMENTS_REQUEST:
            return true;

        case ActionTypes.LRS_STATEMENTS_SUCCESS:
            return (action.payload.more);

        case ActionTypes.LRS_STATEMENTS_FAILURE:
            return false;

        default:
            return state;
    }
};

const reduceStatements = ({statements: state}, action) => {
    switch (action.type) {
        case ActionTypes.LRS_STATEMENTS_SUCCESS:
            return {
                ...state,
                ...action.data.entities.statement
            };

        default:
            return state;
    }
};

const reduceResults = ({result: state}, action) => {
    if (action.type === ActionTypes.LRS_STATEMENTS_SUCCESS) {
        return [...new Set([...state ,...action.data.result])];
    }
    return state;
};

class StatementStore extends ReduceStore {

    getInitialState() {
        return {
            isFetching: false,
            statements: {},
            result: [],
        };
    }

    isFetching() {
        return this.getState().isFetching;
    }

    getStatements() {
        const { result, statements } = this.getState();
        return result.map(id => statements[id]);
    }

    getStatement(id) {
        return this.getState().statements[id] || null;
    }

    reduce(state, action) {
        return {
            isFetching: reduceFetching(state, action),
            statements: reduceStatements(state, action),
            result: reduceResults(state, action)
        };
    }
}

export default new StatementStore(Dispatcher);
